export enum TypeTestQuestion {
  SingleChoice = 1,
  MultipleChoice = 2,
  WriteCode = 3,
  FixCode = 4,
  OpenAnswer = 5
}